import { EditorState } from "@codemirror/state";

export const manuscriptSearchPhrases = EditorState.phrases.of({
    Find: "찾기",
    Replace: "바꾸기",
    next: "다음",
    previous: "이전",
    all: "전체 선택",
    "match case": "대소문자 구분",
    regexp: "정규식",
    "by word": "단어 단위",
    replace: "바꾸기",
    "replace all": "전체 바꾸기",
    close: "닫기",
    "current match": "현재 일치",
    "on line": "줄",
    "replaced match on line $": "$줄의 일치 항목을 바꿨습니다",
    "replaced $ matches": "$개의 일치 항목을 바꿨습니다",
});
